import {
  CHANGE_MODE,
  CHANGE_CHART
} from '../actions';

import { setMode, getMode } from '../../helpers/Utils';

const INIT_STATE = {
  mode: getMode(),
  chart: {
    department_id: -1,
    user_id: -1,
    emotion_id: -1
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CHANGE_MODE:
      setMode(action.payload)
      return {
        ...state,
        mode: action.payload,
      };
    case CHANGE_CHART:
      return {
        ...state,
        chart: {...action.payload}
      };
    default:
      return { ...state };
  }
};
